"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const locations = [{
  city: "Tavistock, ON",
  timezone: "EST"
}, {
  city: "Oxford County",
  timezone: "EST"
}, {
  city: "Perth County",
  timezone: "EST"
}];
const socials = [{
  name: "Facebook",
  url: "https://facebook.com"
}, {
  name: "Instagram",
  url: "https://instagram.com"
}, {
  name: "LinkedIn",
  url: "https://linkedin.com"
}];
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-none" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <p className="text-sm font-sans text-muted-foreground">No links configured.</p>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm uppercase tracking-wider focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="223340" id="footer" className="bg-background text-foreground border-t border-border pt-20 pb-10 px-6 md:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 lg:gap-8">
        
        <div className="flex flex-col gap-8 lg:pr-8">
          <Link to="/" className="inline-block w-fit focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656752/img/av_masonry_logo_footer.png" className="h-7 w-auto" alt="AV MASONRY LTD. Logo" />
          </Link>
          <p className="text-muted-foreground text-sm leading-relaxed font-sans">
            AV MASONRY LTD. provides expert craftsmanship in residential and commercial masonry, specializing in custom stonework, bricklaying, and structural restoration across Ontario.
          </p>
        </div>

        <div className="flex flex-col gap-6">
          <h3 className="font-default text-sm font-semibold uppercase tracking-widest text-foreground">
            Navigation
          </h3>
          <MenuProvider menu_id="footer_menu">
            <FooterLinks />
          </MenuProvider>
        </div>

        <div className="flex flex-col gap-6">
          <h3 className="font-default text-sm font-semibold uppercase tracking-widest text-foreground">
            Service Areas
          </h3>
          <ul className="flex flex-col gap-0">
            {locations.map((loc, i) => <li key={i} data-index={i} className="flex justify-between items-center text-sm font-sans text-muted-foreground border-b border-border/40 py-3 first:pt-0 last:border-0">
                <span className="uppercase tracking-wider">{loc.city}</span>
                <span className="text-xs opacity-60 tracking-widest">{loc.timezone}</span>
              </li>)}
          </ul>
        </div>

        <div className="flex flex-col gap-6">
          <h3 className="font-default text-sm font-semibold uppercase tracking-widest text-foreground">
            Connect
          </h3>
          <ul className="flex flex-col gap-3">
            {socials.map((social, i) => <li key={i} data-index={i}>
                <Link to={social.url} newTab className="font-sans text-sm text-muted-foreground hover:text-primary transition-colors uppercase tracking-wider focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring block w-fit">
                  {social.name}
                </Link>
              </li>)}
          </ul>
        </div>

      </div>

      <div className="max-w-7xl mx-auto mt-24 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-sans text-muted-foreground uppercase tracking-widest">
        <p>© {new Date().getFullYear()} AV MASONRY LTD. All rights reserved.</p>
        <p className="opacity-50">Website Created By Dapper Donkey Co.</p>
      </div>
    </section>;
}